import React from 'react';

/**
 * Renders interest track names for a screening slot.
 * Looks up each stored eventiveId against the master interest track list.
 * Shows the first track name and a "+ More" tooltip for additional ones.
 *
 * @param {string[]} interestTrackIds - eventiveId strings saved on dateTime[].interestTrack
 * @param {Object[]} masterTracks     - master interest track list from state (each has eventiveId, name)
 * @returns {JSX.Element|string}
 */
export function renderInterestTracks(interestTrackIds, masterTracks) {
    const tracks = (interestTrackIds || [])
        .map(evId => (masterTracks || []).find(t => t.eventiveId === evId))
        .filter(Boolean);

    if (tracks.length === 0) return '-';

    return (
        <>
            {tracks[0].name}
            {tracks.length > 1 && (
                <>
                    <span>+ More</span>
                    <div className="tooltip_box">
                        {tracks.map((t, i) => <span key={i}>{t.name}</span>)}
                    </div>
                </>
            )}
        </>
    );
}
